import React, { Component } from 'react'

/**
 * Celda numérica editable del sobre-recibo.
 *
 * Vivía dentro de SobreRecibo.js; se sacó a su propio archivo para que la pestaña de cálculos del
 * finiquito use exactamente la misma celda en vez de una copia parecida.
 *
 * Tres comportamientos que la hacen distinta de un <InputNumber>, y los tres son a propósito:
 *
 *  · Se ve como texto hasta que se enfoca (sin borde ni fondo), porque la tabla de balance tiene
 *    decenas de renglones y con bordes se vuelve ilegible.
 *  · Guarda en `onBlur`, no en `onChange`: cada guardado dispara una petición, y con onChange
 *    saldría una por tecla.
 *  · `getDerivedStateFromProps` sólo acepta el valor de fuera cuando NO se está editando. Sin eso,
 *    la respuesta del servidor pisaría lo que el usuario está escribiendo a media captura.
 *
 * `esManual` sólo cambia el color (azul + negritas): es la marca de que el número lo puso una
 * persona y no una fórmula.
 */
class CeldaEditable extends Component {
  constructor(props) {
    super(props)
    this.state = { editando: false, valorLocal: props.valor }
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.editando) return { valorLocal: props.valor }
    return null
  }

  render() {
    const { esManual, ancho = 80, onGuardar, disabled } = this.props
    const { valorLocal } = this.state

    return (
      <input
        type="number"
        value={valorLocal ?? ''}
        readOnly={disabled}
        style={{
          width: ancho, textAlign: 'right', border: 'none',
          background: 'transparent',
          color:      esManual ? '#1677ff' : 'inherit',
          fontWeight: esManual ? 600 : 400,
          fontSize: 12, outline: 'none',
          cursor: disabled ? 'default' : 'text',
        }}
        onFocus={() => { if (!disabled) this.setState({ editando: true }) }}
        onChange={(e) => { if (!disabled) this.setState({ valorLocal: e.target.value }) }}
        onBlur={() => {
          if (disabled) return
          const v = parseFloat(this.state.valorLocal)
          this.setState({ editando: false })
          if (!isNaN(v) && v !== this.props.valor) onGuardar(v)
        }}
      />
    )
  }
}

export default CeldaEditable
